<template>
  <div class="header" style="height: 64px;background-color: #ffffff;">
    <div class="rowFluid">
      <div class="span6 col-md-12"  >
        <div class="logo" style="margin-left: 40px;">
          <a href="/" title="返回首页">
            <img :src="logoPic" width="160px" alt="乐活元">
          </a>
        </div>
      </div>
      <div class="span4">
        <!-- <div class="mobileMenuBtn">
          <span class="span1"></span>
          <span class="span2"></span>
          <span class="span3"></span>
          <span class="span4"></span>
        </div>
        <div class="mobileMenuBtn_shad"></div> -->
        <div class="header_menu">
          <ul id="menu">
            <li v-for="(items,index) in bannerList" :key="index">
              <a style="font-family: PingFang SC, PingFang SC;
                font-weight: 300;
                cursor: pointer;
                font-size: 14px;
                color: #000000;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                " @click="goHere(items.bannerUrl)" :title='items.bannerName'>{{items.bannerName}}</a>
            </li>

          </ul>
        </div>
      </div>
      <div class="span2"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logoPic: require("../../assets/website/logo.png"),
      type: "/",
      bannerList: [
        {'bannerName': '首页', 'bannerUrl': '/home'},
        {'bannerName': '产品服务', 'bannerUrl': '/product'},
        {'bannerName': '医师服务', 'bannerUrl': '/doctor'},
        {'bannerName': '关于我们', 'bannerUrl': '/aboutus'},
      ]
    };
  },
  methods: {
    goHere(item) {
      this.type = item;
      switch (item) {
        case "/home":
           window.location.hash = 'home';
          break;
        case "/product":
          window.location.hash = 'product';
          break;

        case "/doctor":
          window.location.hash = 'doctor';
          break;

        case "/aboutus":
          window.location.hash = 'aboutus';
          break;
      }
    }
  }
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
@import "../../assets/css/mixin.less";

</style>




// WEBPACK FOOTER //
// src/components/TopBanner/TopBanner.vue